<template>
  <Drawer
    custom-class="pg-drawer-export"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :size="size"
    @close="close"
    @closed="closed"
    @open="getFormData"
  >
    <div class="pg-drawer-export__content">
      <ul class="pg-drawer-export__content-top">
        <li class="pg-drawer-export__content-top-item">
          <span class="pg-drawer-export__content-top-item-label">文件名</span>
          <PgInput placeholder="请输入文件名" clearable v-model="data[exportTitleKey]"></PgInput>
        </li>
        <li class="pg-drawer-export__content-top-item">
          <span class="pg-drawer-export__content-top-item-label">导出字段</span>
          <Checkbox
            class="pg-drawer-export__content-top-checkbox-all"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</Checkbox
          >
          <CheckboxGroup
            class="pg-drawer-export__content-top-checkbox-group"
            v-model="data[exportFieldsKey]"
            @change="handleCheckedCitiesChange"
          >
            <Checkbox
              class="pg-drawer-export__content-top-checkbox"
              v-for="column in columnIds"
              :label="column[columnKey]"
              :key="column[columnKey]"
              >{{ column.title }}</Checkbox
            >
          </CheckboxGroup>
        </li>
      </ul>
      <div class="pg-drawer-export__content-footer">
        <ElButton type="primary" round @click="submit" :loading="sureLoading"> 确定 </ElButton>
      </div>
    </div>
  </Drawer>
</template>
<script setup>
import { toRef, ref, shallowRef, shallowReactive, computed } from 'vue'
import { Drawer, Checkbox, CheckboxGroup } from 'element-ui'
import { useDrawerPack } from '../../../hooks/index'
import { post, get } from '../../../utils/index'
import { pgMessage } from '../../message/index'

const props = defineProps({
  title: {
    type: String,
    default: '导出',
  },
  modal: {
    type: Boolean,
    default: true,
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  size: {
    type: [String, Number],
    default: 600,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  exportTitleKey: {
    type: String,
    default: 'exportExcelTitle',
  },
  exportFieldsKey: {
    type: String,
    default: 'columnIds',
  },
  columnKey: {
    type: String,
    default: 'id',
  },
  getColumnsUrl: {
    type: String,
    default: 'rest/main/dict/getExportTableByCode',
  },
  getColumnsParams: Object,
  parameters: Object,
  exportUrl: String,
})

const emit = defineEmits(['on-cancel', 'update:visible', 'close', 'closed', 'on-ok'])
const { close, closed, showDrawer, onCancel, closeDrawer } = useDrawerPack(
  toRef(props, 'visible'),
  emit
)

const columnIds = shallowRef([])
const data = shallowReactive({
  [props.exportTitleKey]: '',
  [props.exportFieldsKey]: [],
})

const getFormData = async () => {
  const param = {
    tableCode: props.parameters?.tableCode,
    ...props.getColumnsParams,
  }
  const [res] = await get(props.getColumnsUrl, param)
  if (res) {
    columnIds.value = res.data.columnIds ?? []
    data[props.exportTitleKey] = res.data.exportExcelTitle
    data[props.exportFieldsKey] = columnIds.value.reduce((arr, im) => {
      if (im.export) arr.push(im[props.columnKey])
      return arr
    }, [])
  }
}

const checkAll = ref(false)
const isIndeterminate = computed(() => {
  if (checkAll.value) {
    return false
  } else if (data[props.exportFieldsKey].length > 0) {
    return true
  } else {
    return false
  }
})
const handleCheckAllChange = (checked) => {
  checkAll.value = checked
  if (checked) {
    data[props.exportFieldsKey] = columnIds.value.map((column) => column[props.columnKey])
  } else {
    data[props.exportFieldsKey] = []
  }
}

const handleCheckedCitiesChange = (val) => {
  data[props.exportFieldsKey] = val
  if (data[props.exportFieldsKey].length === columnIds.value.length) {
    checkAll.value = true
  } else {
    checkAll.value = false
  }
}

const sureLoading = ref(false)
const submit = async () => {
  if (!data[props.exportTitleKey]) {
    pgMessage.error('文件名必填!')
    return
  }
  if (data[props.exportFieldsKey].length <= 0) {
    pgMessage.error('导出字段不能为空!')
    return
  }
  const param = {
    ...props.parameters,
    parameters: Object.assign({}, props.parameters?.parameters, data),
  }
  sureLoading.value = true
  const [res] = await post(props.exportUrl, param)
  sureLoading.value = false
  if (res) {
    const win1 = window.open(res.data)
    if (!win1 || !win1.location) {
      pgMessage.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
      return
    }
    emit('on-ok')
    closeDrawer()
  }
}
</script>
<style lang="scss">
@import '../style/drawer-export.scss';
</style>
